import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AcabimAuthRole, ContactService, getAllEnumValues, getErrorMessage, parseAuthRole} from '@cas-hub/acabim-common-client';
import {MessageService} from 'primeng/api';
import {OrganisationUser} from '../../../../_models/organisation/organisation-users.model';
import {OrganisationUsersService} from '../../../../_services/organisation/organisation-users.service';
import {FormControl, FormGroup} from '@angular/forms';
import {Contact} from '@cas-hub/acabim-common-client/lib/_models/user.model';

@Component({
    selector: 'acabim-admin-edit-organisation-user',
    templateUrl: './edit-organisation-user.component.html',
    styleUrls: ['./edit-organisation-user.component.scss']
})
export class EditOrganisationUserComponent implements OnInit {

    public get user(): OrganisationUser | undefined {
        return this._user;
    }

    userForm = new FormGroup({
        role: new FormControl()
    });
    @Input()
    public set user(value: OrganisationUser | undefined) {
        this._user = value;
        this.done = false;
        this.isLoading = false;
        if (value && value.user.userId) {
            this.isLoading = true;
            this.contactService.getContactWthUserId(value.user.userId).subscribe(contact => {
                this.contact = contact;
                this.isLoading = false;
            }, error => {
                this.contact = null;
                this.isLoading = false;
            });

        }
        this.refreshSelectedRole();
    }

    private _user?: OrganisationUser;
    contact: Contact | null = null;
    isLoading = false;
    done = false;

    @Output() public userDetailsChanged = new EventEmitter();

    public availableRoles: { name: string, id: number }[] = [];
    public selectedRole: { name: string, id: number } = {name: '', id: 0};

    public constructor(
        private readonly contactService: ContactService,
        private readonly organisationUserService: OrganisationUsersService,
       private readonly message: MessageService
    ) {
        for (const role of getAllEnumValues(AcabimAuthRole)) {
            if (role !== AcabimAuthRole[AcabimAuthRole.None]) {
                this.availableRoles.push({name: role, id: Number(AcabimAuthRole[role as any])});
            }
        }
        this.refreshSelectedRole();
    }

    ngOnInit(): void {
        this.done = false;
        this.isLoading = false;
    }

    public changeRole(): void {
        const role = this.userForm?.get('role')?.value;
        if (this.user && role) {
            const newRole = parseAuthRole(role.name);
            if (newRole) {
                this.isLoading = true;
                this.organisationUserService.changeUserRole(this.user.user.userId, newRole).subscribe(_ => {
                    this.isLoading = false;
                    this.done = true
                }, error => {
                    this.message.add(getErrorMessage(error, 'Error changing user role', 'edit-org-user'));
                    this.refreshSelectedRole();
                });
            }
        }
    }

    public close(): void {
        this.userDetailsChanged.emit();
    }

    private refreshSelectedRole(): void {
        if (this.availableRoles.length > 0) {
            if (this.user) {
                const result = this.availableRoles.find(r => r.name.toLowerCase() === this.user?.role.toLowerCase());
                if (result) {
                    this.selectedRole = result;
                    this.userForm?.get('role')?.setValue(result);
                }
            } else {
                this.selectedRole = this.availableRoles[0];
                this.userForm?.get('role')?.setValue(this.availableRoles[0]);
            }
        }
    }
}
